import { Navigate, Route, Routes } from 'react-router-dom';
import AuthRoute from 'src/components/auth-route';
import Login from 'src/components/login';
import EntrySample from 'src/components/samples/entry-sample';
import ListSample from 'src/components/samples/list-sample';
import { ADMIN_PATH, LOGIN_PATH, ROOT_PATH, pathURL } from './common/constants';
import AdminConsole from './components/admin-console/admin-console';
import AdminRoute from './components/admin-route';
import CspHeader from './components/csp-header';
import ContractPeriodManage from './components/mst-contract-period/mst-contract-period';
import ControlRuleManage from './components/mst-control-rule/mst-control-rule';
import HinmeiManage from './components/mst-himmei/mst-hinmei';
import HinInfoManage from './components/mst-hin-info/mst-hin-info';
import NetRateManage from './components/mst-net-rate/mst-net-rate';
import OfficeManage from './components/mst-office/mst-office';
import ProductManage from './components/mst-product/mst-product';
import RemarksManage from './components/mst-remarks/mst-remarks';
import MstSaleFlow from './components/mst-sale-flow/mst-sale-flow';
import UserManagement from './components/mst-user/mst-user';
import QuotationInput from './components/quotation-input/quotation-input';
import QuotationList from './components/quotation-list/quotation-list';
import ListRegisterSample from './components/samples/list-register-sample';
import ReportingSample from './components/samples/reporting-sample';

const App = () => {
  return (
    <>
      <CspHeader />
      <Routes>
        <Route path={ROOT_PATH} element={<AuthRoute />}>
          <Route index element={<QuotationList />} />
          <Route path={pathURL.QUOTATION_INPUT.pathName} element={<QuotationInput />} />
          <Route path={ADMIN_PATH} element={<AdminRoute />}>
            <Route path={pathURL.ADMIN_CONSOLE.pathName} element={<AdminConsole />} />
            <Route path={pathURL.MST_OFFICE.pathName} element={<OfficeManage />} />
            <Route path={pathURL.MST_PRODUCT.pathName} element={<ProductManage />} />
            <Route path={pathURL.MST_HINMEI.pathName} element={<HinmeiManage />} />
            <Route path={pathURL.MST_NET_RATE.pathName} element={<NetRateManage />} />
            <Route path={pathURL.MST_USER.pathName} element={<UserManagement />} />
            <Route path={pathURL.MST_REMARKS.pathName} element={<RemarksManage />} />
            <Route path={pathURL.MST_SALE_FLOW.pathName} element={<MstSaleFlow />} />
            <Route path={pathURL.MST_RELATION.pathName} element={<HinInfoManage />} />
            <Route path={pathURL.MST_CONTRACT_PERIOD.pathName} element={<ContractPeriodManage />} />
            <Route path={pathURL.MST_CONTROL_RULE.pathName} element={<ControlRuleManage />} />
          </Route>

          {'Sample Component ↓'}
          <Route path="list" element={<ListSample />} />
          <Route path="entry" element={<EntrySample />} />
          <Route path="list-register" element={<ListRegisterSample />} />
          <Route path="reporting" element={<ReportingSample />} />
          {'Sample Component ↑'}
        </Route>
        <Route path={LOGIN_PATH} element={<Login />} />
        <Route path="*" element={<Navigate to={ROOT_PATH} />} />
      </Routes>
    </>
  );
};

export default App;
